import { render, staticRenderFns } from "./HierarchyModal.vue?vue&type=template&id=6c0b4130"
import script from "./HierarchyModal.vue?vue&type=script&lang=js"
export * from "./HierarchyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports